<app-page-title [label]="'Manage ' + shape.title + ' (' + shape.id + ')'" />

@if (shape.category === 'Occupancy') {
  <app-shape-manage-occupancy [shape]="shape" (onSubmit)="occupancySubmitted()"></app-shape-manage-occupancy>
}
